import React, { useCallback } from 'react';

import Box from '../../../Box';
import { Button } from '../../../Buttons';
import LinkButton from '../../../LinkButton';
import Stack from '../../../Stack';
import { filterButtonsStyles } from './style';
import { FilterActionProps } from './types';

function FilterActions(props: FilterActionProps) {
  const { action, disabled, onClear, onPopoverClose, onSave } = props;

  const onPickerSave = useCallback(() => {
    onSave();
    onPopoverClose?.();
  }, [onPopoverClose, onSave]);

  return (
    <>
      <Box className="h-1 bg-divider w-full mb-20 shrink-0" />
      <Stack alignItems="center" className="px-20 pb-12 shrink-0" justifyContent="between">
        <LinkButton className="py-2 px-4" onClick={onClear}>
          Clear
        </LinkButton>
        <Button
          className={filterButtonsStyles}
          disabled={disabled}
          size="small"
          onClick={onPickerSave}>
          {action?.primaryText || 'Apply'}
        </Button>
      </Stack>
    </>
  );
}

export * from './types';
export default React.memo(FilterActions);
